import { MAX_FILE_SIZE_ALLOWED } from '@agroone/entities'
import { Component, input, linkedSignal, output, signal } from '@angular/core'
import { BndButton } from '@bonduelle-it/storybook'
import { AoDocumentUploadOutputList } from '../ao-document-upload/ao-document-upload-output.interface'
import {
  AoDocumentUploadComponent,
  AoDocumentUploadData,
  AoDocumentUploadExistingFile,
} from '../ao-document-upload/ao-document-upload.component'

@Component({
  selector: 'ao-document-button',
  templateUrl: './ao-document-button.component.html',
  imports: [BndButton, AoDocumentUploadComponent],
})
export class AoDocumentButtonComponent {
  readonly initialDocumentList = input<AoDocumentUploadExistingFile[] | null>()
  readonly maxFileCount = input<number>(3)
  readonly maxFileSize = input<number>(MAX_FILE_SIZE_ALLOWED)
  readonly dialogTitle = input<string>('DIALOG.DOCUMENTS.UPLOAD')
  readonly iconType = input<'document' | 'image'>('document')
  readonly disabled = input<boolean>(false)

  readonly allowedFileMimeType = input.required<string[]>()
  readonly allowedFileExtensions = input.required<string[]>()

  // used for farm csr type selection
  readonly typeOptions = input<string[]>()

  readonly onDocumentUpdate = output<AoDocumentUploadOutputList>()

  /** Files picked in the dialog and not saved yet; reset each time the parent passes the saved list again. */
  readonly documentsList = linkedSignal<AoDocumentUploadOutputList | null>(() => {
    this.initialDocumentList()
    return null
  })

  protected readonly isDocumentModalOpen = signal(false)
  protected documentUploadData?: AoDocumentUploadData

  openDocumentDialog() {
    this.documentUploadData = {
      title: this.dialogTitle(),
      allowedMimeTypes: this.allowedFileMimeType(),
      allowedExtensions: this.allowedFileExtensions(),
      maxFileSize: this.maxFileSize(),
      maxFilesAllowed: this.maxFileCount(),
      displayDescription: true,
      existingFiles: this.documentsList() ?? this.initialDocumentList(),
      readOnlyMode: this.disabled(),
      typeOptions: this.typeOptions(),
    }
    this.isDocumentModalOpen.set(true)
  }

  onDocumentDialogResult(v: AoDocumentUploadOutputList | null | undefined): void {
    this.isDocumentModalOpen.set(false)
    if (v == null) return
    this.documentsList.set(v)
    this.onDocumentUpdate.emit(v)
  }
}
